export default {
  Query: {
    group: (_, args, { getCacheKey }) =>
      getCacheKey({ id: args.groupId, __typename: 'Group' }),
    user: (_, args, { getCacheKey }) =>
      getCacheKey({ id: args.userId, __typename: 'User' })
  }
}



// WEBPACK FOOTER //
// ./src/config/cacheRedirects.js